class JKCardColours extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.addEventListener('click', (event) => {
      const button = event.target.closest('.jk-colour-button');
      const card = this.closest('.jk-product');
      if (!button || !card) return;
      this.querySelectorAll('.jk-colour-button').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      card.querySelectorAll('.jk-product-link').forEach((link) => { link.href = button.dataset.url; });
      const image = card.querySelector('[data-jk-card-image]');
      if (image && button.dataset.image) {
        image.src = button.dataset.image;
        image.removeAttribute('srcset');
        const media = card.querySelector('.jk-product-media');
        if (media) media.style.setProperty('--jk-card-background', `url(${JSON.stringify(button.dataset.image)})`);
      }
      const price = card.querySelector('[data-jk-price]');
      if (price && button.dataset.price) price.textContent = button.dataset.price;
    });
  }
}
if (!customElements.get('jk-card-colours')) customElements.define('jk-card-colours', JKCardColours);
